import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { getActiveCampaigns } from '../services/api';
import useAuthStore from '../context/authStore';
import confetti from 'canvas-confetti';
import toast from 'react-hot-toast';
import './CampaignPopup.css';

export default function CampaignPopup() {
  const navigate = useNavigate();
  const { user, userDoc } = useAuthStore();
  const [campaign, setCampaign] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Only show if not seen in this session
    if (sessionStorage.getItem('campaign_popup_seen')) return;

    getActiveCampaigns().then(r => {
      if (r.data && r.data.length > 0) {
        setCampaign(r.data[0]);
        // Show after 10 seconds
        const timer = setTimeout(() => {
          setShow(true);
        }, 10000);
        return () => clearTimeout(timer);
      }
    }).catch(() => {});
  }, []);

  const handleClose = () => {
    setShow(false);
    sessionStorage.setItem('campaign_popup_seen', 'true');
  };

  const handleClaim = () => {
    if (!user) {
      toast.error('سجّل دخولك كطالب لتفعيل الخصم');
      handleClose();
      return navigate('/login');
    }
    if (userDoc?.role !== 'student') {
      return toast.error('هذا العرض للطلاب فقط');
    }

    confetti({
      particleCount: 150,
      spread: 100,
      origin: { y: 0.5 }
    });
    handleClose();
    navigate('/courses');
  };

  if (!campaign) return null;

  return (
    <AnimatePresence>
      {show && (
        <div className="cp-overlay" onClick={handleClose}>
          <motion.div
            className="cp-modal"
            initial={{ scale: 0.5, opacity: 0, y: 100 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.5, opacity: 0, y: 100 }}
            onClick={e => e.stopPropagation()}
          >
            <button className="cp-close" onClick={handleClose}>✕</button>
            <div className="cp-content">
              <div className="cp-icon">🎁</div>
              <span className="cp-badge">هدية لك! ✨</span>
              <h2>وفر حتى {campaign.discountType === 'percentage' ? `${campaign.discountValue}%` : `${campaign.discountValue} ج.م`}</h2>
              <p>استخدم عرض <strong>{campaign.title}</strong> واحصل على وصول كامل لأفضل الكورسات التعليمية في مصر.</p>
              <button className="cp-btn" onClick={handleClaim}>تفعيل الخصم الآن ←</button>
              <p className="cp-footer">ينتهي العرض قريباً جداً!</p>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}
